import { render } from "./MovieDetails.vue?vue&type=template&id=292b35f6"
import script from "./MovieDetails.vue?vue&type=script&lang=js"
export * from "./MovieDetails.vue?vue&type=script&lang=js"
script.render = render

export default script